import * as React from 'react'
import { observer } from 'mobx-react'
import { QuestionEditorComponentProps } from 'jobs/questions/props'
import NumericQuestionViewModel from '../../NumericQuestionViewModel'
import NumericInput from 'components/inputs/NumericInput'

interface Props
  extends QuestionEditorComponentProps<NumericQuestionViewModel> {}

export default observer(function NumericEditorInput({
  vm,
  disabled,
  onEnterDown,
  focus$,
  onFocus,
  isNotValid,
}: Props) {
  const keyDown = React.useCallback(
    (e: React.KeyboardEvent) => e.key === 'Enter' && onEnterDown?.(e),
    [onEnterDown],
  )
  return (
    <NumericInput
      disabled={disabled}
      value={vm.answer}
      mode="draft"
      precision={vm.decimalPlaces}
      placeholder="Numeric..."
      onChange={vm.change}
      onKeyDown={keyDown}
      onFocus={onFocus}
      focus$={focus$}
      isNotValid={isNotValid}
      data-test={'numeric-answer-' + vm.id}
    />
  )
})
